import * as React from 'react';
import { Spin, Button, Form, Input, Alert } from 'antd';
import autobind from 'autobind-decorator';
import { observer } from 'mobx-react';
import * as ReactDOM from 'react-dom';

import { ZuluIcon } from 'src/app/shared/icon';

const FormItem = Form.Item;
// TODO: Cambiar para la nueva validacion


/**
 * Class LoginView
 */
@observer
export class LoginView extends React.Component<LoginViewProps, any> {
	refs: {
		txtUsername: HTMLInputElement
	}

	private model: LoginViewModel;

	/**
	 * Constructor
	 * @param props
	 */
	constructor(props: LoginViewProps) {
		super(props);
		this.model = props.model;

		this.state = {
			errorMessage: '',
			showAccessDenied: false,
			isBusy: false,
			userName: ''
		};
	}

	/**
	 * onChange 
	 * @param name
	 * @param value
	 */
	@autobind
	private onChange(name: string, value: any) {
		this.model[name] = value.target.value;
	}

	/**
	 * loginCommand
	 * @param e
	 */
	@autobind
	private loginCommand(e: any) {
		e.preventDefault();
		const view = this;
		this.setState({ showAccessDenied: false, isBusy: true });
		if (this.model.username != '' && this.model.password != '') {
			this.model.loginCommand()
				.then((result) => {
					if (!result) {
						view.setState({ showAccessDenied: result, isBusy: false });
					}
					this.model.password = '';
				})
				.catch((error) => {
					view.setState({ showAccessDenied: true, isBusy: false, errorMessage: error.message });
					this.model.password = '';
				})
		} else {
			view.setState({ isBusy: false });
		}
	}

	/**
	 * componentDidMount
	 */
	componentDidMount() {
		this.refs.txtUsername.focus();
	}
	/**
	 * emitEmpty
	 */
	emitEmpty() {
		this.setState({ userName: '' });
	}

	/**
	 * Render
	 */
	render() {
		const suffix = this.model.username ? <ZuluIcon type="close-circle" onClick={this.emitEmpty} /> : null;

		return (
			<div className="login-box">
				<h1>Login</h1>
				<Spin
					spinning={this.state.isBusy}
					tip={"Loading..."}
					size="large">
					<Form onSubmit={this.loginCommand}>
						{
							this.state.showAccessDenied && <FormItem>
								<Alert type="error" message={this.state.errorMessage} />
							</FormItem>
						}
						<FormItem>
							<Input
								placeholder="Enter your user name"
								addonBefore={<ZuluIcon type="user" />}
								value={this.model.username}
								onChange={e => this.onChange('username', e)}
								ref="txtUsername"
							/>
						</FormItem>
						<FormItem>
							<Input placeholder={"Please enter your password"}
								addonBefore={<ZuluIcon type="lock" />}
								value={this.model.password}
								type="password"
								onChange={e => this.onChange('password', e)}
							/>
						</FormItem>
						<div className="login-footer">
							<Button type="primary" htmlType="submit">Log in</Button>
						</div>
					</Form>
				</Spin>
			</div>
		);
	}
}



// WEBPACK FOOTER //
// ./src/app/login/login.view.tsx